module.exports = __webpack_public_path__ + "img/anulado.1fa5ba60.png";